import { useState, useEffect } from 'react';
import { useSelfCoachBookingPage } from '@/data/booking';
import {
  Carousel,
  CarouselContent,
  CarouselItem
} from '@/components/ui/carousel';
import NextBooking from './nextBookings/NextBooking';

const NextCoachBookings = () => {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const coachBookings = useSelfCoachBookingPage();

  const bookings = coachBookings.data.nextBookings.map(
    (bookingId) => coachBookings.data.bookings[bookingId]
  );

  useEffect(() => {
    if (!api) {
      return;
    }

    setCurrent(api.selectedScrollSnap() + 1);

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  const handleDotClick = (index) => {
    if (!api) {
      return;
    }
    api.scrollTo(index);
  };

  return (
    <div className="relative pb-6">
      <Carousel setApi={setApi}>
        <CarouselContent>
          {bookings.map((booking) => (
            <CarouselItem key={booking.id}>
              <div className="p-1">
                <NextBooking booking={booking} />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 flex gap-2">
        {bookings.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 rounded-full transition-colors ${
              index === current - 1
                ? 'bg-primary'
                : 'bg-muted-foreground/50 hover:bg-muted-foreground/75'
            }`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default NextCoachBookings;
